/* ══════════════════════════════════════════════════════════════════════
   DDR NAME RESOLUTION + STATE MAPPING

   Two naming systems are in play:
     • the workbook uses CURRENT names   — "UttarPradesh-6", "VADODARA"
     • ddr.json uses LEGACY names        — "UP-6", "Gujarat-Vadodara UA"
   Nothing matches on a raw string compare, which is why map regions come
   out grey. resolveDdrToGeo() bridges them; DDR_STATE rolls DDRs up to
   states for the state-level view.
   ══════════════════════════════════════════════════════════════════════ */

/* ── Authoritative DDR → State mapping ──────────────────────────────── */
export const DDR_STATE = {
  "UttarPradesh-11+12": "Uttar Pradesh",
  "HYDERABAD": "Telangana",
  "AndhraPradesh-1": "Andhra Pradesh",
  "AndhraPradesh-2": "Andhra Pradesh",
  "AndhraPradesh-3": "Andhra Pradesh",
  "AndhraPradesh-4": "Andhra Pradesh",
  "VIJAYWADA": "Andhra Pradesh",
  "VIZAG": "Andhra Pradesh",
  "Assam-1": "Assam", "Assam-2": "Assam", "Assam-3": "Assam",
  "Assam-4": "Assam", "Assam-5": "Assam",
  "Bihar-1": "Bihar", "Bihar-2": "Bihar", "Bihar-3": "Bihar",
  "Bihar-4": "Bihar", "Bihar-5": "Bihar", "Bihar-6": "Bihar",
  "PATNA": "Bihar",
  "Chhattisgarh-1": "Chhattisgarh", "Chhattisgarh-2": "Chhattisgarh",
  "Chhattisgarh-3": "Chhattisgarh",
  "DURG-BHILAINAGAR": "Chhattisgarh", "Raipur": "Chhattisgarh",
  "DELHI - UA": "Delhi",
  "Delhi-Delhi UA": "Delhi",
  "AHMEDABAD": "Gujarat",
  "Gujarat-1": "Gujarat", "Gujarat-2": "Gujarat", "Gujarat-3": "Gujarat",
  "Gujarat-4": "Gujarat", "Gujarat-5": "Gujarat", "Gujarat-6": "Gujarat",
  "RAJKOT": "Gujarat", "SURAT": "Gujarat", "VADODARA": "Gujarat",
  "FARIDABAD": "Haryana", "GURGAON": "Haryana",
  "Haryana-1": "Haryana", "Haryana-2": "Haryana", "Haryana-3": "Haryana",
  "HimachalPradesh-1": "HP - JK", "HimachalPradesh-2": "HP - JK",
  "Jammu_&_Kashmir-1": "HP - JK",
  "DHANBAD": "Jharkhand", "JAMSHEDPUR": "Jharkhand",
  "Jharkhand-1": "Jharkhand", "Jharkhand-2": "Jharkhand",
  "Jharkhand-3": "Jharkhand", "Jharkhand-4": "Jharkhand",
  "Jharkhand-5": "Jharkhand", "RANCHI": "Jharkhand",
  "BANGALORE": "Karnataka",
  "Karnataka-1": "Karnataka", "Karnataka-2": "Karnataka",
  "Karnataka-3": "Karnataka", "Karnataka-4": "Karnataka",
  "Karnataka-5": "Karnataka", "Karnataka-6": "Karnataka",
  "Kerala-1": "Kerala", "Kerala-2": "Kerala", "Kerala-3": "Kerala",
  "KOCHI": "Kerala",
  "Goa-1": "Goa",
  "Maharashtra-1": "Maharashtra", "Maharashtra-2": "Maharashtra",
  "Maharashtra-3": "Maharashtra", "Maharashtra-4": "Maharashtra",
  "Maharashtra-5": "Maharashtra", "Maharashtra-6": "Maharashtra",
  "Maharashtra-7": "Maharashtra",
  "MUMBAI": "Maharashtra", "NAGPUR": "Maharashtra",
  "NASHIK": "Maharashtra", "PUNE": "Maharashtra",
  "BHOPAL": "Madhya Pradesh", "GWALIOR": "Madhya Pradesh",
  "INDORE": "Madhya Pradesh", "JABALPUR": "Madhya Pradesh",
  "FBO_SLMG": "Madhya Pradesh",
  "MadhyaPradesh-1": "Madhya Pradesh", "MadhyaPradesh-2 + 3": "Madhya Pradesh",
  "MadhyaPradesh-4": "Madhya Pradesh", "MadhyaPradesh-5": "Madhya Pradesh",
  "NorthEast-1": "North East", "NorthEast-2": "North East",
  "NorthEast-3": "North East", "NorthEast-4": "North East",
  "NorthEast-5": "North East", "NorthEast-6": "North East",
  "NorthEast-7": "North East",
  "Orissa-1": "Orissa", "Orissa-2": "Orissa", "Orissa-3": "Orissa",
  "Orissa-4": "Orissa", "Orissa-5": "Odisha",
  "AMRITSAR": "Punjab", "CHANDIGARH": "Punjab", "LUDHIANA": "Punjab",
  "Punjab-1": "Punjab", "Punjab-2": "Punjab",
  "Punjab-3": "Punjab", "Punjab-4": "Punjab",
  "JAIPUR": "Rajasthan", "JODHPUR": "Rajasthan", "KOTA": "Rajasthan",
  "Rajasthan-1": "Rajasthan", "Rajasthan-2+3": "Rajasthan",
  "Rajasthan-4": "Rajasthan", "Rajasthan-5": "Rajasthan",
  "Rajasthan-6": "Rajasthan",
  "TEL NORTH 1": "Telangana", "TEL NORTH 2": "Telangana",
  "TEL NORTH 3": "Telangana", "TEL SOUTH 1": "Telangana",
  "TEL SOUTH 2": "Telangana", "TEL SOUTH 3": "Telangana",
  "CHENNAI": "Tamil Nadu", "COIMBATORE": "Tamil Nadu",
  "MADURAI": "Tamil Nadu", "Pondicherry-1": "Tamil Nadu",
  "TamilNadu-1": "Tamil Nadu", "TamilNadu-2": "Tamil Nadu",
  "TamilNadu-3": "Tamil Nadu", "TamilNadu-4": "Tamil Nadu",
  "TamilNadu-5": "Tamil Nadu", "TamilNadu-6": "Tamil Nadu",
  "AGRA": "Uttar Pradesh", "ALLAHABAD": "Uttar Pradesh",
  "KANPUR": "Uttar Pradesh", "LUCKNOW": "Uttar Pradesh",
  "MEERUT": "Uttar Pradesh", "NOIDA": "Uttar Pradesh",
  "UttarPradesh-1": "Uttar Pradesh", "UttarPradesh-10": "Uttar Pradesh",
  "UttarPradesh-3": "Uttar Pradesh", "UttarPradesh-4": "Uttar Pradesh",
  "UttarPradesh-5": "Uttar Pradesh", "UttarPradesh-6": "Uttar Pradesh",
  "UttarPradesh-7": "Uttar Pradesh", "UttarPradesh-8": "Uttar Pradesh",
  "UttarPradesh-9": "Uttar Pradesh", "VARANASI": "Uttar Pradesh",
  "Uttarakhand-1": "Uttranchal", "Uttarakhand-3": "Uttarakhand",
  "Asansole": "West Bengal", "KOLKATA": "West Bengal",
  "TwentyFourParganas": "West Bengal",
  "WestBengal-1": "West Bengal", "WestBengal-2": "West Bengal",
  "WestBengal-3": "West Bengal", "WestBengal-4": "West Bengal",
};

/* Short codes used on the state chart, mirroring the source deck */
export const STATE_CODE = {
  "Andhra Pradesh": "AP", "Assam": "ASM", "Bihar": "BIH",
  "Chhattisgarh": "CG", "Delhi": "DEL", "Gujarat": "GUJ",
  "Haryana": "HAR", "Jharkhand": "JKD", "Karnataka": "KAR",
  "Kerala": "KER", "Madhya Pradesh": "MP", "North East": "NE",
  "Orissa": "ORI", "Rajasthan": "RAJ", "Telangana": "TEL",
  "Uttar Pradesh": "UP", "West Bengal": "WB", "HP - JK": "HP-JK",
  "Punjab": "PUN", "Uttranchal": "UK", "Tamil Nadu": "TN",
  "Maharashtra": "MAH",
};

/* ── Normalisation ──────────────────────────────────────────────────── */
// Legacy abbreviations -> the full word the current names use
const PREFIX_ALIAS = {
  up: "uttarpradesh", uk: "uttarakhand", mah: "maharashtra",
  mp: "madhyapradesh", ap: "andhrapradesh", wb: "westbengal",
  pun: "punjab", tlg: "telangana", tel: "telangana",
  jk: "jammukashmir", hp: "himachalpradesh", tn: "tamilnadu",
  ka: "karnataka", od: "orissa", ori: "orissa", ne: "northeast",
};

// Cities the two systems spell differently
const CITY_ALIAS = {
  vizag: "visakhapatnam", vijaywada: "vijayawada",
  asansole: "asansol", twentyfourparganas: "24parganas",
};

// Noise that appears in the legacy names only
const NOISE = /\b(ua|m\s*corp\.?|corp|municipal|urban\s*agglomeration)\b/gi;

function tokens(name) {
  return String(name || "")
    .replace(/\(.*?\)/g, " ")     // "(M CORP.)"
    .replace(NOISE, " ")
    .replace(/&/g, "and")
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter(Boolean);
}

/** Canonical key: expand the leading abbreviation, drop separators. */
export function normalizeDdr(name) {
  const t = tokens(name);
  if (!t.length) return "";
  if (PREFIX_ALIAS[t[0]]) t[0] = PREFIX_ALIAS[t[0]];
  const joined = t.join("");
  return CITY_ALIAS[joined] || joined;
}

/** Trailing digits, e.g. "uttarpradesh6" -> "6"; handles "2and3" splits. */
function numbersOf(name) {
  const m = String(name || "").match(/\d+/g);
  return m || [];
}

/** "MadhyaPradesh-2 + 3" covers two legacy DDRs — expand to both. */
export function expandCombined(name) {
  const raw = String(name || "");
  const m = raw.match(/^(.*?)[-\s]*(\d+)\s*\+\s*(\d+)\s*$/);
  if (!m) return [raw];
  const [, stem, a, b] = m;
  const clean = stem.replace(/[-\s]+$/, "");
  return [`${clean}-${a}`, `${clean}-${b}`];
}

/* ── Index + resolver ───────────────────────────────────────────────── */
export function buildGeoIndex(geoNames) {
  const byKey = new Map();
  const list = [];
  geoNames.forEach(g => {
    const key = normalizeDdr(g);
    if (!byKey.has(key)) byKey.set(key, g);
    list.push({ geo: g, key, nums: numbersOf(key) });
  });
  return { byKey, list };
}

/**
 * Resolve a current DDR name to the matching ddr.json feature name(s).
 * Returns [] when nothing matches, so callers can report coverage.
 */
export function resolveDdrToGeo(ddr, index) {
  const parts = expandCombined(ddr);
  const hits = [];

  parts.forEach(part => {   // eslint-disable-line
    const key = normalizeDdr(part);
    if (!key) return;

    // 1. exact canonical match  ("uttarpradesh6" == "uttarpradesh6")
    if (index.byKey.has(key)) { hits.push(index.byKey.get(key)); return; }

    const nums = numbersOf(key);
    const stem = key.replace(/\d+/g, "");

    // 2. city / suffix match  ("vadodara" -> "gujaratvadodara")
    const suffix = index.list.filter(e =>
      e.key !== key && e.key.endsWith(key) && key.length >= 4 && !nums.length);
    if (suffix.length === 1) { hits.push(suffix[0].geo); return; }
    if (suffix.length > 1) { hits.push(...suffix.map(e => e.geo)); return; }

    // 3. same stem AND same number  ("telangananorth1" vs "telangananorth")
    const stemNum = index.list.filter(e => {
      const eStem = e.key.replace(/\d+/g, "");
      if (eStem !== stem) return false;
      if (!nums.length && !e.nums.length) return true;
      return nums.some(n => e.nums.includes(n));
    });
    if (stemNum.length) { hits.push(...stemNum.map(e => e.geo)); return; }

    // 4. stem family fallback. "TEL NORTH 1/2/3" must collapse onto the
    //    unnumbered legacy "TLG North", but "UttarPradesh-12" (no legacy
    //    twin) must NOT light up every numbered UP polygon. The rule: fall
    //    back only when the legacy family carries no numbering of its own.
    const family = index.list.filter(e => e.key.replace(/\d+/g, "") === stem);
    if (!family.length) return;
    if (nums.length && family.some(e => e.nums.length)) return;
    hits.push(...family.map(e => e.geo));
  });

  return [...new Set(hits)];
}